import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import websitePage from 'hoc/websitePage/websitePage';
import AboutPage from 'components/AboutPage/AboutPage';
import Block from 'components/structure/Block/Block';
import Section from 'components/structure/Section';
import { paddingBuilder } from 'styles/themeUtils';

import SectionTimeline from './patterns/SectionTimeline/SectionTimeline';
import SectionBrandGuideline from './patterns/SectionBrandGuideline/SectionBrandGuideline';
import SectionStatistics from './patterns/SectionStatistics/SectionStatistics';
import SectionOurTeam from './patterns/SectionOurTeam/SectionOurTeam';
import SectionPress from './patterns/SectionPress/SectionPress';
import SectionContact from './patterns/SectionContact/SectionContact';

function Press() {
  return (
    <AboutPage>
      <Section minHeight="auto">
        <Block
          blockWidth="100%"
          alignItems="center"
          padding={{
            default: paddingBuilder.bottom(0),
            desktop: paddingBuilder.bottom(0),

          }}
        >
          <Typography
            color="black"
            gutterBottom={2}
            intlKey="PRESS.TITLE"
            variant="title"
          />

          <Typography
            variant="paragraph2"
            intlKey="PRESS.SUBTITLE"
            color="black"
            intlValues={{
              blogLink: (
                <Link
                  intlKey="PRESS.SUBTITLE.BLOG_LINK"
                  typographyProps={{
                    variant: 'paragraph2',
                  }}
                  color="primary"
                  href="https://blog.nubank.com.br/imprensa"
                />
              ),
            }}
          />
        </Block>
      </Section>

      <SectionBrandGuideline />
      <SectionTimeline />
      <SectionStatistics />
      <SectionPress />
      <SectionOurTeam />
      <SectionContact />
    </AboutPage>
  );
}

export default websitePage({
  routeKey: 'PRESS',
})(Press);
